module.exports = __webpack_public_path__ + "static/media/HSD_logo.cb331bb6.jpg";